<mat-card class="mat-elevation-z0" style="margin-top: 10px">
  <div class="justify-content-between d-flex">
    <span class="address-text space-left space-bottom">
      {{ typeTranslation }}
    </span>
  </div>

  <div class="d-flex">
    <div class="flexer">
      <div class="space-left">
        <div class="space-bottom">
          <div>
            <span>{{ temporaryMaterialDisplay }}</span>

            <span *ngIf="inputWindowSticker.foil">
              - {{ inputWindowSticker.foil.name }}
            </span>

            <span *ngIf="inputWindowSticker.laminate">
              - {{ inputWindowSticker.laminate.name }}
            </span>
          </div>

          <div>
            <div
              *ngIf="
                inputWindowSticker.type === 'WindowSticker' &&
                inputWindowSticker.standardStickerParts != null
              "
            >
              <div
                *ngFor="
                  let standardStickerPartDisplay of standardStickerPartDisplays;
                  let i = index;
                  let first = first;
                  let last = last;
                  trackBy: trackById
                "
              >
                <span class="font-weight-bold">
                  Sticker{{ first && last ? '' : ' #' + (i + 1) }}:
                </span>
                {{ standardStickerPartDisplay.size }}
                <div
                  *ngIf="standardStickerPartDisplay.layoutDescription != null"
                >
                  <span class="preserve-line-break inline-flex">
                    Extra info sticker{{ first && last ? '' : ' #' + (i + 1) }}:
                    {{ standardStickerPartDisplay.layoutDescription }}
                  </span>
                </div>
              </div>
            </div>

            <div *ngIf="inputWindowSticker.type === 'CustomWindowSticker'">
              <div
                *ngFor="
                  let stickerpart of customWindowSticker.stickerParts;
                  let i = index;
                  let last = last
                "
              >
                <span class="font-weight-bold">Sticker #{{ i + 1 }}:</span>

                <span>
                  <span class="font-weight-bold"> Raam:</span>
                  {{
                    stickerpart.windowHeight ? stickerpart.windowHeight : '0'
                  }}
                  cm h x
                  {{ stickerpart.windowWidth ? stickerpart.windowWidth : '0' }}
                  cm b
                </span>

                <span>
                  -
                  <span class="font-weight-bold">Sticker:</span>
                  {{
                    stickerpart.stickerHeight ? stickerpart.stickerHeight : '0'
                  }}
                  cm h x
                  {{
                    stickerpart.stickerWidth ? stickerpart.stickerWidth : '0'
                  }}
                  cm b
                </span>

                <div
                  class="upper-space preserve-line-break"
                  [ngClass]="!last ? 'bottom-space' : ''"
                  *ngIf="stickerpart.description?.length > 0"
                >
                  <span class="preserve-line-break inline-flex">
                    Opmerking sticker #{{ i + 1 }}:
                    {{ stickerpart.description }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="space-bottom">
          <div class="font-weight-bold">Ontwerp:</div>

          <span *ngIf="inputWindowSticker.newDesign">
            De klant levert het ontwerp aan
          </span>

          <span
            *ngIf="
              inputWindowSticker.newDesign != null &&
              !inputWindowSticker.newDesign
            "
          >
            Inpress maakt het ontwerp aan
          </span>

          <div
            *ngIf="inputWindowSticker.generalExtraInfo != null"
            class="upper-space"
          >
            <span class="preserve-line-break">
              {{ inputWindowSticker.generalExtraInfo }}
            </span>
          </div>
        </div>

        <div>
          <ul>
            <li>
              <span>Titel:</span>

              <span class="strong">
                &nbsp;{{ getTitle(inputWindowSticker.title) }}
              </span>
            </li>

            <li>
              <span class="preserve-line-break display-contents">
                <span>{{ multiplePhoneNumbers ? 'Telnrs:' : 'Telnr:' }}</span>

                <span
                  *ngFor="
                    let group of productPhoneNumberGroups;
                    let last = last;
                    trackBy: trackById
                  "
                >
                  <span
                    class="strong"
                    *ngIf="productPhoneNumberGroups.length > 1"
                  >
                    {{ group.companyName }}:
                  </span>

                  <span
                    *ngFor="
                      let phoneNumber of group.phoneNumbers;
                      let ilast = last
                    "
                  >
                    <a class="click-link strong" href="tel:{{ phoneNumber }}">
                      &nbsp;{{ phoneNumber }}
                    </a>

                    <span class="strong">
                      {{ !ilast && group.phoneNumbers.length > 1 ? ',' : '' }}
                    </span>
                  </span>

                  <span class="strong">
                    {{
                      !last && productPhoneNumberGroups.length > 1 ? ' / ' : ''
                    }}
                  </span>
                </span>

                <span
                  class="strong"
                  *ngIf="productPhoneNumberGroups.length === 0"
                >
                  Geen telefoonnummers
                </span>
              </span>
            </li>

            <li>
              <span class="preserve-line-break display-contents">
                <span>Tekst: </span>

                <span class="inline-flex">
                  {{
                    inputWindowSticker.text == null ||
                    inputWindowSticker.text === ''
                      ? 'Geen tekst'
                      : inputWindowSticker.text
                  }}
                </span>
              </span>
            </li>

            <li *ngIf="inputWindowSticker.immoscoopLogo != null">
              <img
                src="/assets/{{
                  inputWindowSticker.immoscoopLogo
                    ? 'immoscoop_banner'
                    : 'immoscoop_banner_kruis'
                }}.png"
                class="immoscoop-logo"
              />
            </li>
            <li *ngIf="inputWindowSticker.spottoLogo != null">
              <img
                src="/assets/{{
                  inputWindowSticker.spottoLogo
                    ? 'spotto_banner'
                    : 'spotto_banner_kruis'
                }}.png"
                class="spotto-logo"
              />
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="flexer">
      <div class="d-flex images">
        <div *ngFor="let item of inputWindowSticker.productAssets; index as i">
          <div
            *ngIf="
              (item?.archived === false || client) &&
              (item?.formSection === 'windowDesign' ||
                item?.formSection === 'internalDesign')
            "
            class="loadedImg align-middle"
            matTooltip="{{ item?.asset?.name }}"
          >
            <div class="d-flex box click-link" class="max-summary-width">
              <a
                download="{{ item.asset.name }}"
                href="/api/assets/{{ item.asset.uuid }}"
                style="margin-right: 7px"
                class="d-flex box"
              >
                <div class="filename">
                  {{ item?.asset?.name | shortenTextSplitOn : '.' : 10 }}
                </div>

                <a>
                  <mat-icon aria-hidden="false" aria-label="remove">
                    cloud_download
                  </mat-icon>
                </a>
              </a>
            </div>

            <a
              class="click-link"
              href="/api/assets/{{ item.asset.uuid }}"
              *ngIf="isImage(item.asset)"
              data-lightbox="product"
            >
              <img
                *ngIf="isImage(item.asset)"
                class="max-summary-width max-summary-height"
                src="/api/assets/{{ item.asset.uuid }}"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</mat-card>
